/**
 * @return {{click: string}}
 */
export const game = () => ({
  click: 'jouer',
});
